import {
	ColorGrayDarkest,
	ColorWhite,
	SpaceXxLarge,
	FontSizeSmall,
	LineHeightMedium,
	ColorOrangeLight,
	ColorBlueLightest,
	ColorTealLighter,
	ColorTealLight,
	ColorYellowLight,
	ColorGrayLight,
} from "../../lib/src/design-tokens/variables";

export const FancySyntaxHighlighterStyle = {
	'pre[class*="language-"]': {
		background: ColorGrayDarkest,
		color: ColorWhite,
		padding: SpaceXxLarge,
		margin: 0,
		fontSize: FontSizeSmall,
		lineHeight: LineHeightMedium,
		MozTabSize: 4,
		tabSize: 4,
		overflow: "auto",
		whiteSpace: "pre",
	}, //background
	"attr-name": { color: ColorTealLighter },
	"attr-value": { color: ColorOrangeLight },
	string: { color: ColorOrangeLight },
	punctuation: { color: ColorGrayLight },
	"script-punctuation": { color: ColorWhite },
	"class-name": { color: ColorTealLight }, // JSX tag
	parameter: { color: ColorBlueLightest },
	property: { color: ColorBlueLightest },
	constant: { color: ColorBlueLightest },
	boolean: { color: ColorBlueLightest },
	number: { color: ColorBlueLightest },
	keyword: { color: ColorBlueLightest },
	tag: { color: ColorTealLight },
	operator: { color: ColorWhite },
	function: { color: ColorYellowLight },
};
